import { telemetryApiUrl } from "../util/constants";
import { Sans } from "../util/sdk";
import TelemetryException from "./TelemetryException";
import type { Telemetry } from "./TelemetryModel";

export const store = async (telemetry: Telemetry): Promise<Telemetry> => {
  if (!telemetryApiUrl) {
    return telemetry;
  }

  const tokens = await Sans.sdk.core.api.tokens.freshTokens();
  const response = await fetch(telemetryApiUrl, {
    method: "POST",
    body: JSON.stringify(telemetry),
    headers: {
      "Content-Type": "application/json",
      "X-ACCESS-TOKEN": `Bearer ${tokens.id}`,
    },
  });

  const json = await response.json();
  if (json.message) {
    throw new TelemetryException(json.message);
  }

  return telemetry;
};
